var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    viewBox: "0 0 53 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8265 44.6789C33.607 48.3239 25.0554 48.6984 16.4518 44.9575C9.48539 41.9507 3.70539 36.6873 0 30.6736C1.77857 32.177 3.85357 33.3802 6.07675 34.4323C14.9617 38.657 23.8449 38.3677 30.0965 34.443C30.0924 34.4389 30.0899 34.4361 30.0872 34.4323C21.1942 27.5155 13.6354 18.4936 8.00379 11.1266C6.81743 9.92364 5.92811 8.42 5.03902 7.06682C11.8567 13.3818 22.6767 21.3505 26.5292 23.607C18.3788 14.8852 11.1158 4.06 11.4117 4.36C24.3065 17.592 36.3124 25.1105 36.3124 25.1105C36.7095 25.3375 37.0161 25.5268 37.2627 25.6957C37.5224 25.0252 37.7504 24.3289 37.9422 23.607C40.0172 15.9384 37.6463 7.21682 32.4583 0C44.4629 7.3675 51.5781 21.2005 48.6129 32.7789C48.5356 33.0911 48.4515 33.3993 48.3611 33.7023C48.3956 33.7441 48.4302 33.7875 48.4649 33.832C54.3927 41.3505 52.7627 49.3191 52.0218 47.8157C48.8061 41.4316 42.8531 43.3836 39.8265 44.6789Z",
    fill: "#00D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftLogo);
export default __webpack_public_path__ + "static/media/swift-logo.d20f3a7bb9ed5eebc2c408a2c0de3bc1.svg";
export { ForwardRef as ReactComponent };